// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"a9df8d4c","81":"f374cee0"}[chunkId] + ".chunk.js";
};